export default __webpack_public_path__ + "static/media/fan-coil-unit.e1e3c36a.jpg";